import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { fetchCleanerDashboardProperties } from "@/lib/fetchCleanerDashboardProperties";
import { isValidCleanerEntityId } from "@/lib/cleanerQueryGuards";
import { cleanerPropertiesQueryKey } from "@/lib/cleanerQueryKeys";

const STALE_MS = 1000 * 60 * 5;
const GC_MS = 1000 * 60 * 30;

export function useCleanerDashboardProperties(
  userId: string | null | undefined,
  orgId: string | null | undefined,
  isRoleLoading: boolean
) {
  const { t } = useTranslation();

  const idsReady =
    isValidCleanerEntityId(userId ?? undefined) &&
    isValidCleanerEntityId(orgId ?? undefined) &&
    !isRoleLoading;

  return useQuery({
    queryKey: cleanerPropertiesQueryKey(userId ?? undefined, orgId ?? undefined),
    queryFn: ({ signal }) => fetchCleanerDashboardProperties(orgId!, t, signal),
    enabled: idsReady,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: keepPreviousData,
  });
}
